import { render, staticRenderFns } from "./report-svod-plan.vue?vue&type=template&id=2c415211&scoped=true&"
import script from "./report-svod-plan.vue?vue&type=script&lang=ts&"
export * from "./report-svod-plan.vue?vue&type=script&lang=ts&"
import style0 from "./report-svod-plan.vue?vue&type=style&index=0&id=2c415211&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c415211",
  null
  
)

export default component.exports